<template>
  <News code="news" />
</template>
<script>
import News from "./news.vue";

export default {
  name: "Imgs",
  components: {
    News,
  },
  data() {
    return {
      pageData: {},
    };
  },
  created() {},
  methods: {},
};
</script>
